// User names and IDs come from the customer's Slack workspace and are
// untrusted; render as text, never markup.

import { isNumber, isString } from "../utils/schemaUtils";

export interface SlackUserItem {
  id: string;
  name: string;
  realName?: string;
  isBot?: boolean;
}

export interface SlackUsersPayload {
  type: "slack_users";
  query: string;
  totalResults: number;
  users: SlackUserItem[];
}

const isSlackUserItem = (v: unknown): v is SlackUserItem => {
  if (!v || typeof v !== "object") return false;
  const r = v as Record<string, unknown>;
  return (
    isString(r.id) &&
    isString(r.name) &&
    (r.realName === undefined || isString(r.realName)) &&
    (r.isBot === undefined || typeof r.isBot === "boolean")
  );
};

export const parseSlackUsersPayload = (v: unknown): SlackUsersPayload | null => {
  if (!v || typeof v !== "object") return null;
  const r = v as Record<string, unknown>;
  if (r.type !== "slack_users") return null;
  if (!isString(r.query)) return null;
  if (!isNumber(r.totalResults)) return null;
  if (!Array.isArray(r.users) || !r.users.every(isSlackUserItem)) return null;
  return {
    type: "slack_users",
    query: r.query,
    totalResults: r.totalResults,
    users: r.users,
  };
};
